import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { ImageIcon } from 'lucide-react';
/** A series' or an image's thumbnail in the tag editor, or a placeholder when it has none. */
export function DicomThumbnail({ url, className }) {
    if (!url) {
        return (_jsx("span", { className: cn('bg-muted inline-flex shrink-0 items-center justify-center rounded', className), children: _jsx(ImageIcon, { className: "text-muted-foreground h-4 w-4", "aria-hidden": true }) }));
    }
    return (_jsx("img", { src: url, alt: "", className: cn('shrink-0 rounded bg-black object-cover', className), loading: "lazy" }));
}
